import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  handlePurchasePlanCoach,
  handlePurchasePlanData,
} from "../../../redux/features/coach/actions/authAction";
import Loader from "../../../components/loader";
import { coachPaths } from "../../../routes/coach";

const Subscription = () => {
  const { isLoading, subscriptionPlan } = useSelector(
    (state) => state.coach.auth
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(handlePurchasePlanData());
  }, []);

  const handlePurchasePlan = (value) => {
    const callback = (response) => {
      // if (response) {
      navigate(coachPaths?.CoachDashboard);
      // }
    };
    const data = {
      subscription_id: value?.subscription_id,
      total_price: value?.price,
    };
    dispatch(handlePurchasePlanCoach({ payload: data, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <section class=" py-3">
        <div class="container-fluid">
          <div class="row ">
            <div class="col-md-4 mx-auto">
              <div class="ct_signup_logo mb-3">
                <img src="assets/img/Nuvio_logo.png" alt="" />
              </div>
              <div class="mt-0 text-center">
                <h2 class="ct_fs_32 ct_fw_600 mb-3 ct_darkblue_text">
                  Choose Your Plan
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="container mt-5">
          <div class="row">
            {subscriptionPlan?.length != 0 &&
              subscriptionPlan?.map((item, i) => (
                <div class="col-lg-4 col-md-6 mb-4">
                  <div
                    class="ct_pricing_card p-3"
                    style={{ borderColor: "#8ECAE6" }}
                  >
                    <div>
                      {i == 1 && (
                        <span
                          class="ct_most_popular_badge ct_flex_shrink_0 position-absolute ct_fw_600"
                          style={{
                            backgroundColor: "var(--yellow) ",
                            color: "var(--darkblue)",
                            top: "-18px",
                            right: "-12px",
                          }}
                        >
                          Most Popular
                        </span>
                      )}
                      <div class="ct_pricing_title mt-3 text-start">
                        <p class="mb-2 ct_fs_24_new ct_darksky_blue_text">
                          {item?.title ?? ""}
                        </p>
                        <h2 class="ct_fs_44  mb-0 ct_fw_600">
                          ${item?.price ?? 0}{" "}
                        </h2>
                        <p class="mb-0 mt-2 ct_fs_20 ct_orange_text">
                          {item?.description ?? ""}
                        </p>
                      </div>
                      <ul class="ct_mt_30 mb-4 mt-4">
                        {item?.details?.map((item) => (
                          <li className="ct_fs_18">
                            <i
                              class="fa-solid fa-check"
                              style={{ backgroundColor: "#023047" }}
                            ></i>{" "}
                            {item?.feature_name ?? ""}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div class="mt-auto pt-5">
                      <a
                        class="ct_yellow_btn ct_darkblue_btn w-100 ct_h_48"
                        onClick={() => handlePurchasePlan(item)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Subscription;
